import React, { Component } from "react";
import Translation from "../../../common/translation/translation.component";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils'
import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import Icons from "../../../icon";
import { ACTION_TYPES, TYPE_FUNCTION } from "../../../../constants/external-constants";
export class InventoryConfirmation extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      acceptConf:false,
      selected:[],
      options:[
        { value: 'one', label: 'Option One' },
        { value: 'two', label: 'Option Two' },
    ],
      selectedTwo:[],
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
      this.setState({ show: true });
      if (typeof this.props.resetError === TYPE_FUNCTION) {
          this.props.resetError(false)
      }
      
    }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }

  handelConfirmation() {
    if (typeof this.props.confirmAction === TYPE_FUNCTION) {  
        this.props.confirmAction(); 
        if (typeof this.props.enableEdit === TYPE_FUNCTION) {
            this.props.enableEdit();
        }
    }   
    if (this.props.haveError) {
      this.handleClose()
    }
    this.setState({acceptConf:true})
  }

  handelSaveConfirmation() {
    this.handleClose()
    if (typeof this.props.toggleDropdown === TYPE_FUNCTION) {          
        this.props.toggleDropdown()
    }
    this.setState({acceptConf:false})
  }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

  render(){
    const { show }=this.state;
    return(
      <>

      {
          this.props.titleBtn===ACTION_TYPES.Delete ?
          <Icons
              customClassName="icon-trash"
              name="trash-can"
              size="20px"
              containerClass="icon-circle-plus-container"
              onClick={this.handleShow.bind(this)}
          />
          :
          this.props.showUpdateBtn ?
          <Icons
              customClassName="icon-check-reg"
              name="check"
              size="20px"
              containerClass="icon-circle-plus-container"  
              onClick={this.handleShow.bind(this)}
          /> 
          :
                        <div className="tooltip-container">
                            <div className={`${this.props.enableHover ? 'btn-tooltiptext' : ''}`}>
                                <Button disabled={!this.props.enableAddBtn} onClick={this.handleShow.bind(this)} className="save-details-btn">
                                    {this.props.titleBtn}
                                </Button>
                                <div className="tooltip-text-container">
                                    <span className="tooltip-text">{this.props.btnTooltip}</span>
                                </div>     
                            </div>
                        </div>
      }
            
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-rematch inventory-confirmation-wrapper"
      >
        <Modal.Header closeButton>
            <Modal.Title>{this.props.titleBtn === ACTION_TYPES.Delete ? <Translation translationKey={"delete"} /> :
                this.props.titleBtn === ACTION_TYPES.Update ? <Translation translationKey={"update"} /> : <Translation translationKey={"modal_confirmation_title"} />}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>        
               {
                this.props.haveError ?
                  this.props.errorMessage
                :
                  !this.props.haveError &&
                   ( !this.state.acceptConf ? ` Are you sure you want ${this.props.titleBtn=== ACTION_TYPES.Add ? "add?" : 
                    this.props.titleBtn=== ACTION_TYPES.Delete ? "delete?" :
                    this.props.titleBtn=== ACTION_TYPES.Update ? "update?":""}`
                    :
                    `${this.props.titleBtn=== ACTION_TYPES.Add ? "Circuit has been added" : 
                    this.props.titleBtn=== ACTION_TYPES.Delete ? "Circuit has been deleted" :
                    this.props.titleBtn=== ACTION_TYPES.Update ? "Circuit has been updated":""}`  )              
               }
        </Modal.Body>
        <Modal.Footer>
          {
            !this.state.acceptConf &&
            <Button variant="secondary" onClick={this.handleClose.bind(this)}>
                <Translation translationKey={"cancel_button"} />
            </Button> 
          }
                 
          {
            !this.state.acceptConf ?
            <Button variant="primary" onClick={this.handelConfirmation.bind(this)}><Translation translationKey={"ok"} /></Button>
            :
            <Button variant="primary" onClick={this.handelSaveConfirmation.bind(this)}><Translation translationKey={"ok"} /></Button>  
          }                 
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
